module.exports = "/images/profilePicture.png?f5ef4263a9c36adac59559031d67a0b7";